export const QA_NAME_USER_PROFILE_PAGE_DELETE_ACTION_CONFIRMATION =
  'confirmation'
